export const OperationType = {
    Installation: "INSTALLATION",
    Migration: "MIGRATION",
    UrlTransfer: "URL_TRANSFER",
    CompanyTransfer: "COMPANY_TRANSFER",
    CustomerTransfer: "CUSTOMER_TRANSFER",
    Delete: "DELETE",
    ForceDelete: "FORCE_DELETE",
    GetInstallationInfo: "GET_INSTALLATION_INFO"
};



// WEBPACK FOOTER //
// ./src/common/operationTypes.js